function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import * as React from 'react';
import './ReturnChevron.css';
import { Link } from 'react-router-dom';
import cs from 'classnames';
import ButtonLabel from '../../Buttons/ButtonLabel/ButtonLabel';
import Chevron from '../../Icons/Chevron/Chevron';
import ThemeContext from '../../ThemeContext';
export default function ReturnChevron(_ref) {
  var to = _ref.to,
    onClick = _ref.onClick,
    i18n = _ref.i18n,
    i18nKey = _ref.i18nKey,
    className = _ref.className;
  var theme = React.useContext(ThemeContext);
  return /*#__PURE__*/React.createElement(Link, {
    to: to,
    onClick: onClick,
    className: cs('_dm-return-link', _defineProperty({}, className, className), _defineProperty({}, theme, theme))
  }, /*#__PURE__*/React.createElement(ButtonLabel, {
    className: "_dm-return-link__label",
    i18n: i18n,
    i18nKey: i18nKey,
    hideLabel: true
  }), /*#__PURE__*/React.createElement(Chevron, null));
}